/**
 * Wes avatar — illustrated mark for panel and launcher.
 */

import { WES_AVATAR_IMAGE_STYLE } from './wesAvatarFrame';

export interface WesIconProps {
  size?: number;
  pulse?: boolean;
  className?: string;
}

export function WesIcon({ size = 28, pulse = false, className = '' }: WesIconProps) {
  return (
    <span
      className={`relative inline-flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full ${className}`}
      style={{ width: size, height: size }}
    >
      {pulse && (
        <span className="absolute inset-0 rounded-full ring-2 ring-indigo-400/40 animate-agent-pulse" />
      )}
      <img
        src="/assets/wes-avatar.png"
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
        style={WES_AVATAR_IMAGE_STYLE}
        draggable={false}
      />
    </span>
  );
}
